import { Trans } from "@lingui/react";
import * as React from 'react';
import styled from 'styled-components';
import { Modal, Button } from '@prezi/common-components';
import { useConfig } from '../../../../utils/config';
const ModalBackgroundContainer = styled.div.withConfig({
  displayName: "ConfirmRemoveModal__ModalBackgroundContainer",
  componentId: "sc-1oicetu-0"
})(["background-color:white;width:410px;border-radius:4px;padding:30px;"]);
const ButtonContainer = styled.div.withConfig({
  displayName: "ConfirmRemoveModal__ButtonContainer",
  componentId: "sc-1oicetu-1"
})(["display:flex;justify-content:flex-end;a:first-child{margin-right:8px;}"]);
export default (({
  isOpen,
  onClose,
  onConfirm,
  collaboratorId
}) => {
  const {
    modalRootId
  } = useConfig();
  return React.createElement(Modal, {
    isOpen: isOpen,
    onClose: onClose,
    rootId: modalRootId
  }, React.createElement(ModalBackgroundContainer, null, React.createElement(Trans, {
    id: "Are you sure you want to remove yourself from this folder?"
  }), React.createElement(ButtonContainer, null, React.createElement(Button, {
    onClick: () => {
      if (collaboratorId) {
        onConfirm(collaboratorId);
        onClose();
      }
    },
    theme: "red"
  }, "Ok"), React.createElement(Button, {
    onClick: onClose
  }, "Cancel"))));
});